import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-900">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-slate-600 dark:text-slate-400">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    // APR-11c (Michael, Part 52) — keep the destination: an approval link
    // opened while signed out comes back to that approval after sign-in.
    return <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />;
  }

  // SEC-1b — every team member signs in with two factors (Michael, 2026-10-19):
  // one who has not set it up does that first.
  if (user.mfa_enrollment_required) {
    return <Navigate to="/security/two-factor" replace />;
  }

  return children;
}

export default ProtectedRoute;
